<template>
	<div
		class="status"
		:class="{
			new: status === statuses.NEW,
			'to-do': status === statuses.TO_DO,
			dismissed: status === statuses.DISMISSED,
			done: status === statuses.DONE,
			'done-for-you': status === statuses.DONE_FOR_YOU,
			scheduled: status === statuses.SCHEDULED,
			upcoming: status === statuses.UPCOMING,
		}"
	>
		{{ status }}
	</div>
</template>

<script>
import { ALERTS } from './constants.js';

export default {
	name: 'AlertStatus',
	props: {
		status: String,
	},
	data() {
		return {
			statuses: ALERTS.STATUSES,
		};
	},
};
</script>

<style lang="scss" scoped>
.status {
	font-weight: bold;
	text-transform: uppercase;
	box-sizing: border-box;
	border-radius: 6px;
	width: fit-content;
	height: fit-content;
	@include rem('font-size', 13px);
	@include rem('padding', 4px 6px);
}

.new {
	color: $white;
	background: $brand-blue;
}

.to-do {
	color: $brand-blue;
	background: rgba($brand-blue, 0.05);
	border: 1px solid $brand-blue;
}

.dismissed {
	color: $black;
	background: rgba($b360-color--gray__darker, 0.05);
	border: 1px solid $b360-color--gray__darker;
}

.scheduled {
	color: $b360-color--purple;
	background: rgba($b360-color--purple, 0.05);
	border: 1px solid $b360-color--purple;
}

.upcoming {
	color: $b360-color--orange__light;
	background: rgba($b360-color--orange__light, 0.05);
	border: 1px solid $b360-color--orange__light;
}

.done,
.done-for-you {
	color: $b360-color--green__success;
	border: 1px solid $b360-color--green__success;
	background: rgba($b360-color--green__success, 0.05);
}
</style>
